import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const resources = {
  it: {
    translation: {
      title: "Dott. Nicolò Pareto Veterinario - Cura professionale per i tuoi animali",
      ctaTitle: "Prenota una Visita Oggi Stesso",
      generazioniTxt: "Da generazioni, la famiglia Pareto si dedica con passione al mondo degli animali: dall'allevamento di galline alla medicina veterinaria, sempre con amore e competenza per il benessere animale.",
      ctaDescription: "Non aspettare! Prenota subito una visita per il tuo amico a quattro zampe e assicuragli le migliori cure possibili.",
      btnPrenota: "Prenota ora",
      contactsTitle: "Contatti",
      addressLabel: "Indirizzo:",
      phoneLabel: "Telefono:",
      emailLabel: "Email:",
      openingHoursTitle: "Orari",
      weekdaysHours: "Lun-Mer e Ven:",
      thursdayMorningLabel: "Giovedi Mattina:",
      saturdayHours: "Sabato:",
      sundayLabel: "Domenica:",
      closedLabel: "Chiuso",
      serviceTitle: "I Nostri Servizi",
      services: "I Nostri Servizi",
      sectionTitle2: "Perché Sceglierci",
      featureTitle1: "Cura Compassionevole",
      featureDescr1: "Trattiamo ogni animale con amore e rispetto, proprio come faremmo con i nostri.",
      featureTitle2: "Esperienza Comprovata",
      featureDesc2: "Il nostro staff di veterinari certificati ha decenni di esperienza combinata.",
      featureTitle3: "Orari Flessibili",
      featureDescription3: "Appuntamenti disponibili nei weekend e servizio di reperibilità 24/7.",
      featureTitle4: "Spazio Sicuro",
      featureDescription4: "Struttura all'avanguardia progettata per il comfort dei pazienti.",
      btnNav1: "Home",
      btnNav2: "Chi Siamo",
      btnNav3: "Prenota Visita",
      btnNav4: "Pubblicazioni",
      infoBox1: "Veterinario",
      infoBox2: "Anno di Laurea",
      infoBox3: "Specializzazione",
      subHeading: "La storia della nostra Famiglia",
      family: "Famiglia",
      subHeading3: "tradizione veterinaria da tre generazioni",
      nonno: "Nonno",
      nonnotext:
        "Classe 1928, Giulio Pareto nasce a Ventimiglia: figlio di un ferroviere ed una casalinga, già durante la Seconda Guerra Mondiale la sua capacità di resilienza viene messa a dura prova. Fuggendo con la famiglia dalla sua città natale seguendo i binari della ferrovia, arriva ad Albenga nel 1944: dal secondo dopoguerra con la sua sola forza di volontà apre un piccolo allevamento di galline ovaiole, che diventerà alla fine degli anni 80 il più grande della Liguria arrivando a contare nel periodo di massima espansione ben 15.000 capi di bestiame. Giulio si è spento nel 1986, lasciando un vuoto indelebile ma una eredità che non è stata abbandonata. La sua vita ha narrato una storia, quella dell’amore per gli animali, che è riuscito a trasmettere alle generazioni successive. Ci piace ricordarlo in mezzo alle sue amate galline, accompagnato dagli inossidabili pastori belga che non lasciavano mai il suo fianco.",
      papatext:
        "Nato ad Albenga nel 1960, è cresciuto nell’allevamento avicolo di famiglia e fin da subito per lui la vocazione professionale è stata chiara. Laureatosi in Medicina Veterinaria nel 1984, ha successivamente conseguito la specializzazione in Patologia Aviare e Tecnologia Avicola nel 1987; fino al 1998 ha mantenuto attivo lo storico allevamento di galline ovaiole dei Pareto e dal 1999 al 2007 ha gestito un secondo studio veterinario a Laigueglia. Nel 1986 ha fondato il suo studio veterinario ad Albenga, pilastro fondamentale di quel che poi è divenuto lo Studio Veterinario Pontelungo. Oltre all’impegno professionale, Fabrizio coltiva la passione per la barca a vela e lo sport, con un particolare occhio di riguardo all’avvicinare i giovani alle discipline del mare",
      nicotext:
        "Classe 1992, si laurea alla facoltà di Medicina Veterinaria di Pisa nel 2018, Nicolò ha lavorato fino al 2019 in Irlanda prima di tornare in Italia, dove ha collaborato con diverse cliniche come veterinario generalista ed emergenzista. Da luglio 2019 ha affiancato il padre nell’attività di famiglia, conseguendo nel 2024 il General Practitioner Certificate (GP Cert) in Endoscopia presso la International School of Veterinary Postgraduate Studies (ISVPS). Nicolò collabora con diverse associazioni per la difesa degli animali e nel tempo libero coltiva la sua passione per la Letteratura. Nel 2024 ha pubblicato un romanzo dal titolo “Saliborn, ovvero il Processo Creativo”",
      teamIntro:
        "Il nostro team unisce esperienza, specializzazione e attenzione al benessere di ogni paziente. Qui sotto trovi i professionisti che ogni giorno si prendono cura dei tuoi animali.",
      teamSection: "Il nostro team",
      collaboratorRole: "Collaboratrice",
      birthDateLabel: "Data di nascita",
      masterLabel: "Master",
      silviaBirth: "4 dicembre 2000",
      silviaSpec: "Nutrizione e dietetica clinica del cane e del gatto",
      silviaMaster: 'Master di II Livello in "Nutrizione e dietetica clinica del cane e del gatto"',
      silviatext:
        "Silvia Scorza, nata il 4 dicembre 2000, ha conseguito la laurea nel 2025 e si è specializzata in nutrizione e dietetica clinica del cane e del gatto. Ha inoltre completato un Master di II Livello nella stessa disciplina, approfondendo l'approccio nutrizionale personalizzato per supportare salute, prevenzione e percorsi clinici degli animali da compagnia. Porta nel team competenza aggiornata e una particolare attenzione al benessere alimentare di cani e gatti.",
      serv1: "Visite di medicina generale",
      serv2: "Chirurgia",
      serv3: "Diagnostica avanzata",
      serv4: "Medicina preventiva",
      serv5: "Gestione emergenze",
      serv6: "Nutrizione e dietetica clinica",
      service1Title: "Medicina Generale",
      service1Description: "Visite di routine e controlli preventivi per mantenere il tuo animale in buona salute.",
      service1Date: "Ogni giorno",
      service1Tag: "Servizio Base",
      service2Title: "Chirurgia Veterinaria",
      service2Description: "Interventi chirurgici specializzati eseguiti dal nostro team esperto in un ambiente sterile e sicuro.",
      service2Date: "Su appuntamento",
      service2Tag: "Specialistica",
      service3Title: "Diagnostica Avanzata",
      service3Description: "Radiografie, ecografie e analisi di laboratorio per diagnosi precise e tempestive.",
      service3Date: "Su appuntamento",
      service3Tag: "Diagnostica",
      philosophy: "La nostra filosofia",
      philosophy1: "Cure personalizzate per ogni animale",
      philosophy2: "Ambiente a basso stress",
      philosophy3: "Coinvolgimento dei proprietari",
      philosophy4: "Prevenzione come priorità",
      welcome: "Benvenuti allo Studio Veterinario Pontelungo",
      subtitle: "Da oltre 40 anni ci prendiamo cura con passione dei vostri animali",
      logoAlt: "Studio Veterinario Pontelungo",
      veterinari: "Veterinari",
      toggleMenu: "Apri/Chiudi menu",
      closeMenu: "Chiudi menu",
      backToHome: "Torna alla homepage",
      slide1Title: "Studio Veterinario Professionale",
      slide1Description: "Cura di qualità per i tuoi animali domestici",
      slide1Alt: "Studio Veterinario",
      slide2Title: "Staff Qualificato",
      slide2Description: "Un team di esperti per ogni esigenza del tuo animale",
      slide2Alt: "Staff Qualificato",
      slide3Title: "Struttura All'avanguardia",
      slide3Description: "Tecnologia moderna per diagnosi precise e tempestive",
      slide3Alt: "Struttura All'avanguardia",
      metaDescription: "Chirurgo veterinario Nicolò Dottor Pareto nella cura e nel benessere dei tuoi animali domestici.",
      metaKeywords: "veterinario, Studio Veterinario, cura animali, animali domestici, cani, gatti, visita veterinaria",
      prevSlide: "Slide precedente",
      nextSlide: "Slide successiva",
      goToSlide: "Vai alla slide {{index}}",
      noImages: "Nessuna immagine disponibile",
      imageNotAvailable: "Immagine non disponibile",
      slideAlt: "Immagine slide",
      bookAppointmentTitle: "Prenota una visita veterinaria",
      selectDate: "Seleziona una data",
      cancel: "Annulla",
      confirm: "Conferma",
      selectRoom: "Seleziona Sala",
      normalShift: "Sala Visite 1",
      shift2: "Sala Visite 2",
      availableTimesMorning: "Orari disponibili - Mattina",
      availableTimesAfternoon: "Orari disponibili - Pomeriggio",
      noMorningTimes: "Nessun orario disponibile per la mattina.",
      noAfternoonTimes: "Nessun orario disponibile per il pomeriggio.",
      selectTimeSlot: "Seleziona orario {{time}} per Sala Visite 1",
      selectTimeSlotShift2: "Seleziona orario {{time}} per Sala Visite 2",
      googleCalendarEvents: "Eventi Google Calendar per il",
      noEvents: "Nessun evento trovato nel Google Calendar per questa data.",
      noTitleEvent: "Evento senza titolo",
      allDayEvent: "Intera giornata",
      viewOnGoogleCalendar: "Vedi su Google Calendar",
      bookingDetails: "Dati per la prenotazione",
      ownerFirstName: "Nome proprietario *",
      ownerLastName: "Cognome proprietario *",
      email: "Email *",
      petName: "Nome animale *",
      petType: "Tipo di animale *",
      selectPetType: "Seleziona...",
      dog: "Cane",
      cat: "Gatto",
      rabbit: "Coniglio",
      bird: "Uccello",
      reptile: "Rettile",
      other: "Altro",
      treatment: "Trattamento *",
      selectTreatment: "Seleziona un trattamento...",
      treatmentAnnualVaccine: "Vaccino annuale",
      treatmentCheckup: "Visita di controllo",
      treatmentBloodTests: "Esami del sangue (specificare nelle note il motivo)",
      treatmentXRay: "Radiografia (specificare nelle note il motivo)",
      treatmentTherapy: "Somministrazione terapie (specificare nelle note il motivo)",
      treatmentPreSurgery: "Visita di controllo pre-chirurgia",
      treatmentPostSurgery: "Visita di controllo post-chirurgia",
      treatmentOther: "Altro (specificare nelle note il motivo)",
      treatmentLeishmaniasis: "Vaccino leishmaniosi",
      treatmentFeLV: "Vaccino FeLV",
      treatmentAnnualFeLV: "Vaccino annuale + Vaccino FeLV",
      treatmentMyxoRHD: "Vaccino Myxo RHD",
      notes: "Note",
      notesPlaceholder: "Inserisci eventuali note o descrizione del problema",
      bookingSummary: "Riepilogo prenotazione",
      bookingSummaryText: "Visita per <strong>{{petName}}</strong>{{petType}} per <strong>{{treatment}}</strong> il <strong>{{date}} alle {{time}}</strong> ({{room}}). Email di conferma a: <strong>{{email}}</strong>",
      noPetName: "(nome animale)",
      noTreatment: "(nessun trattamento)",
      selectTime: "Seleziona un orario per completare la prenotazione",
      bookingInProgress: "Prenotazione in corso...",
      confirmBooking: "Conferma prenotazione",
      calendarError: "Avviso: Errore nel recupero degli eventi di Google Calendar. Assicurati che il service account sia configurato correttamente e che il calendario sia condiviso.",
      criticalError: "Si è verificato un errore critico nel recupero dei dati di disponibilità.",
      missingFields: "Per favore, completa tutti i campi obbligatori, inclusa l'email, il tipo di trattamento e il turno.",
      bookingSuccess: "Appuntamento per {{petName}} il {{date}} alle {{time}} ({{room}}) è stato prenotato con successo nel calendario. Riceverai una conferma via email a {{email}}.",
      bookingError: "Errore durante la prenotazione dell'appuntamento su Google Calendar: {{error}}",
      privacyTitle: "Informativa sulla Privacy",
      privacyLastUpdate: "Ultimo aggiornamento: 29 Luglio 2025",
      privacyIntro: "La presente informativa descrive come lo Studio Veterinario Pontelungo raccoglie, utilizza e protegge i dati personali in conformità al Regolamento Generale sulla Protezione dei Dati (GDPR).",
      privacySection1: "1. Titolare del trattamento",
      privacyController: "Il titolare del trattamento dei dati è lo Studio Veterinario Pontelungo.",
      privacyAddress: "Via Pontelungo, 123, 17031 Albenga (SV), Italia",
      privacyPhone: "Telefono: +39 3663568072",
      privacySection2: "2. Dati raccolti",
      privacyDataCollectedIntro: "Raccogliamo i seguenti dati personali:",
      privacyData1: "Nome e cognome del proprietario",
      privacyData2: "Indirizzo email",
      privacyData3: "Numero di telefono",
      privacyData4: "Nome e tipo di animale",
      privacyData5: "Informazioni sul trattamento richiesto",
      privacyData6: "Note aggiuntive fornite dall'utente",
      privacyData7: "Dati di prenotazione (data, ora, turno)",
      privacySection3: "3. Finalità del trattamento",
      privacyPurposeIntro: "I dati raccolti vengono utilizzati per:",
      privacyPurpose1: "Gestire le prenotazioni delle visite veterinarie",
      privacyPurpose2: "Fornire servizi veterinari richiesti",
      privacyPurpose3: "Inviare conferme e promemoria via email",
      privacyPurpose4: "Adempiere agli obblighi legali e amministrativi",
      privacySection4: "4. Base giuridica",
      privacyLegalBasisIntro: "Il trattamento dei dati si basa su:",
      privacyLegalBasis1: "Il consenso dell'utente per la gestione delle prenotazioni e l'invio di comunicazioni",
      privacyLegalBasis2: "L'esecuzione di un contratto o obblighi precontrattuali relativi ai servizi veterinari",
      privacySection5: "5. Modalità di trattamento",
      privacyProcessing1: "I dati sono trattati con strumenti elettronici e manuali",
      privacyProcessing2: "Adottiamo misure di sicurezza per proteggere i dati da accessi non autorizzati",
      privacyProcessing3: "I dati sono accessibili solo al personale autorizzato",
      privacySection6: "6. Conservazione dei Dati",
      privacyRetention: "I dati personali sono conservati per il tempo necessario a fornire i servizi richiesti e per adempiere agli obblighi legali, salvo richieste di cancellazione.",
      privacySection7: "7. Comunicazione a terzi",
      privacyThirdPartyIntro: "I dati possono essere condivisi con:",
      privacyThirdParty1: "Google Calendar per la gestione degli appuntamenti, nel rispetto delle normative sulla protezione dei dati.",
      privacySection8: "8. Diritti dell’interessato",
      privacyRightsIntro: "L’utente ha diritto di:",
      privacyRight1: "Accedere ai propri dati personali",
      privacyRight2: "Richiedere la rettifica o la cancellazione dei dati",
      privacyRight3: "Limitare il trattamento dei dati",
      privacyRight4: "Opporsi al trattamento",
      privacyRight5: "Richiedere la portabilità dei dati",
      privacyRightsContact: "Per esercitare questi diritti, contattare:",
      privacySection9: "9. Reclami",
      privacyComplaints: "Per eventuali reclami, è possibile contattare l’Autorità Garante per la protezione dei dati personali o l’autorità di controllo competente.",
      privacySection10: "10. Aggiornamenti",
      cookieText: "Utilizziamo i cookie per gestire le prenotazioni e migliorare la tua esperienza. Leggi la nostra ",
      cookieDetails: " per maggiori dettagli.",
      Accetta: "Accetta",
      Rifiuta: "Rifiuta",
      bookingStatus: "Prenotazione in corso...",
      bookingSuccessModal: "È stata prenotata una visita veterinaria per il tuo animale {{petName}} ({{petType}}). Una mail di conferma è stata inviata all'indirizzo {{email}}.",
      bannerTextPrenota: "Avviso ai signori clienti: se si desidera prenotare una visita specialistica o fuori dagli orari disponibili sul sito si prega di contattare telefonicamente lo studio veterinario al numero",
      privacyUpdates: "La presente informativa può essere aggiornata periodicamente. Si invita a consultarla regolarmente.",
      sundayNotAvailable: "Le domeniche non sono disponibili per la prenotazione."
    }
  },
  en: {
    translation: {
      title: "Dr. Nicolò Pareto Veterinarian - Professional Care for Your Animals",
      ctaTitle: "Book an Appointment Today",
      allestimentoTxt: "We are working to create fantastic content. Come back soon to discover what's new!",
      generazioniTxt: "For generations, the Pareto family has dedicated itself with passion to the world of animals: from raising chickens to veterinary medicine, always with love and expertise for animal welfare.",
      ctaDescription: "Don't wait! Book an appointment now for your four-legged friend and ensure the best possible care.",
      btnPrenota: "Book Now",
      contactsTitle: "Contacts",
      addressLabel: "Address:",
      phoneLabel: "Phone:",
      emailLabel: "Email:",
      openingHoursTitle: "Opening Hours",
      weekdaysHours: "Mon-Wed & Fri:",
      thursdayMorningLabel: "Thursday Morning:",
      saturdayHours: "Saturday:",
      sundayLabel: "Sunday:",
      closedLabel: "Closed",
      serviceTitle: "Our Services",
      services: "Our Services",
      sectionTitle2: "Why Choose Us",
      featureTitle1: "Compassionate Care",
      featureDescr1: "We treat every animal with love and respect, just as we would our own.",
      featureTitle2: "Proven Expertise",
      featureDesc2: "Our team of certified veterinarians brings decades of combined experience.",
      featureTitle3: "Flexible Hours",
      featureDescription3: "Appointments available on weekends and 24/7 on-call service.",
      featureTitle4: "Safe Space",
      featureDescription4: "A state-of-the-art facility designed for patient comfort.",
      btnNav1: "Home",
      btnNav2: "About Us",
      btnNav3: "Book an Appointment",
      btnNav4: "Publications",
      infoBox1: "Veterinarian",
      infoBox2: "Year of Graduation",
      infoBox3: "Specialization",
      infoBox4: "Father",
      subHeading: "Our Family History",
      family: "Family",
      subHeading3: "a veterinary tradition for three generations",
      nonno: "Grandfather",
      nonnotext:
        "Born in 1928, Giulio Pareto was born in Ventimiglia: the son of a railway worker and a homemaker, his resilience was tested during the Second World War. Fleeing with his family from his hometown Along the railway tracks, he arrived in Albenga in 1944: after the war, with sheer determination, he opened a small egg-laying hen farm, which by the late 1980s became the largest in Liguria, reaching a peak of 15,000 animals. Giulio passed away in 1986, leaving an indelible void but a legacy that has not been abandoned. His life told a story of love for animals, which he passed down to future generations. We fondly remember him among his beloved hens, always accompanied by his loyal Belgian shepherds.",
      papatext:
        "Born in Albenga in 1960, he grew up in the family poultry farm, and his professional calling was clear from the start. Graduating in Veterinary Medicine in 1984, he later specialized in Avian Pathology and Poultry Technology in 1987; until 1998, he kept the historic Pareto egg-laying hen farm active and managed a second veterinary practice in Laigueglia from 1999 to 2007. In 1986, he founded his veterinary practice in Albenga, a cornerstone of what later became the Pontelungo Veterinary Studio. Beyond his professional commitment, Fabrizio nurtures a passion for sailing and sports, with a particular focus on introducing young people to marine disciplines.",
      nicotext:
        "Born in 1992, Nicolò graduated from the Faculty of Veterinary Medicine in Pisa in 2018. He worked in Ireland until 2019 before returning to Italy, where he collaborated with various clinics as a general and emergency veterinarian. Since July 2019, he has worked alongside his father in the family practice, earning a General Practitioner Certificate (GP Cert) in Endoscopy from the International School of Veterinary Postgraduate Studies (ISVPS) in 2024. Nicolò collaborates with several animal welfare organizations and, in his free time, pursues his passion for literature. In 2024, he published a novel titled 'Saliborn, or the Creative Process.'",
      teamIntro:
        "Our team combines experience, specialization, and care for every patient's wellbeing. Below you will find the professionals who look after your animals every day.",
      teamSection: "Our team",
      collaboratorRole: "Collaborator",
      birthDateLabel: "Date of birth",
      masterLabel: "Master",
      silviaBirth: "December 4, 2000",
      silviaSpec: "Clinical nutrition and dietetics of dogs and cats",
      silviaMaster: "Second-level Master's degree in \"Clinical nutrition and dietetics of dogs and cats\"",
      silviatext:
        "Silvia Scorza, born on December 4, 2000, graduated in 2025 and specialized in clinical nutrition and dietetics of dogs and cats. She also completed a second-level Master's degree in the same field, focusing on personalized nutritional approaches to support pet health, prevention, and clinical care. She brings up-to-date expertise and particular attention to the dietary wellbeing of dogs and cats.",
      serv1: "General medicine visits",
      serv2: "Surgery",
      serv3: "Advanced diagnostics",
      serv4: "Preventive medicine",
      serv5: "Emergency care",
      serv6: "Clinical nutrition and dietetics",
      service1Title: "General Medicine",
      service1Description: "Routine visits and preventive check-ups to keep your pet in good health.",
      service1Date: "Every day",
      service1Tag: "Basic Service",
      service2Title: "Veterinary Surgery",
      service2Description: "Specialized surgical procedures performed by our expert team in a sterile and safe environment.",
      service2Date: "By appointment",
      service2Tag: "Specialized",
      service3Title: "Advanced Diagnostics",
      service3Description: "X-rays, ultrasounds, and laboratory tests for accurate and timely diagnoses.",
      service3Date: "By appointment",
      service3Tag: "Diagnostics",
      philosophy: "Our Philosophy",
      philosophy1: "Personalized care for every animal",
      philosophy2: "Low-stress environment",
      philosophy3: "Owner involvement",
      philosophy4: "Prevention as a priority",
      welcome: "Welcome to Pontelungo Veterinary Studio",
      subtitle: "For over 40 years, we have been passionately dedicated to the care of your animals",
      logoAlt: "Pontelungo Veterinary Studio",
      veterinari: "Veterinarians",
      toggleMenu: "Open/Close menu",
      closeMenu: "Close menu",
      backToHome: "Back to homepage",
      slide1Title: "Professional Veterinary Studio",
      slide1Description: "Quality care for your pets",
      slide1Alt: "Veterinary Studio",
      slide2Title: "Qualified Staff",
      slide2Description: "A team of experts for every need of your pet",
      slide2Alt: "Qualified Staff",
      slide3Title: "Cutting-edge Equipment",
      slide3Description: "Modern technology for accurate and timely diagnoses",
      slide3Alt: "Cutting-edge Equipment",
      metaDescription: "Veterinary surgeon Dr. Nicolò Pareto dedicated to the care and well-being of your pets.",
      metaKeywords: "veterinarian, veterinary studio, pet care, pets, dogs, cats, veterinary visit",
      prevSlide: "Previous slide",
      nextSlide: "Next slide",
      goToSlide: "Go to slide {{index}}",
      noImages: "No images available",
      imageNotAvailable: "Image not available",
      slideAlt: "Slide image",
      bookAppointmentTitle: "Book a Veterinary Appointment",
      selectDate: "Select a Date",
      cancel: "Cancel",
      confirm: "Confirm",
      selectRoom: "Select room",
      normalShift: "Examination room 1",
      shift2: "Examination room 2",
      availableTimesMorning: "Available Times - Morning",
      availableTimesAfternoon: "Available Times - Afternoon",
      noMorningTimes: "No morning times available.",
      noAfternoonTimes: "No afternoon times available.",
      selectTimeSlot: "Select time slot {{time}} for Examination room 1",
      selectTimeSlotShift2: "Select time slot {{time}} for Examination room 2",
      googleCalendarEvents: "Google Calendar Events for",
      noEvents: "No events found in Google Calendar for this date.",
      noTitleEvent: "Untitled event",
      allDayEvent: "All day",
      viewOnGoogleCalendar: "View on Google Calendar",
      bookingDetails: "Booking Details",
      ownerFirstName: "Owner's First Name *",
      ownerLastName: "Owner's Last Name *",
      email: "Email *",
      petName: "Pet Name *",
      petType: "Pet Type *",
      selectPetType: "Select...",
      dog: "Dog",
      cat: "Cat",
      rabbit: "Rabbit",
      bird: "Bird",
      reptile: "Reptile",
      other: "Other",
      treatment: "Treatment *",
      selectTreatment: "Select a treatment...",
      treatmentAnnualVaccine: "Annual Vaccine",
      treatmentCheckup: "Check-up",
      treatmentBloodTests: "Blood Tests (specify reason in notes)",
      treatmentXRay: "X-Ray (specify reason in notes)",
      treatmentTherapy: "Therapy Administration (specify reason in notes)",
      treatmentPreSurgery: "Pre-Surgery Check-up",
      treatmentPostSurgery: "Post-Surgery Check-up",
      treatmentOther: "Other (specify reason in notes)",
      treatmentLeishmaniasis: "Leishmaniasis Vaccine",
      treatmentFeLV: "FeLV Vaccine",
      treatmentAnnualFeLV: "Annual Vaccine + FeLV Vaccine",
      treatmentMyxoRHD: "Myxo RHD Vaccine",
      notes: "Notes",
      notesPlaceholder: "Enter any notes or description of the issue",
      bookingSummary: "Booking Summary",
      bookingSummaryText: "Appointment for <strong>{{petName}}</strong>{{petType}} for <strong>{{treatment}}</strong> on <strong>{{date}} at {{time}}</strong> ({{room}}). Confirmation email to: <strong>{{email}}</strong>",
      noPetName: "(pet name)",
      noTreatment: "(no treatment)",
      selectTime: "Select a time to complete the booking",
      bookingInProgress: "Booking in progress...",
      confirmBooking: "Confirm Booking",
      calendarError: "Warning: Error retrieving Google Calendar events. Ensure the service account is properly configured and the calendar is shared.",
      criticalError: "A critical error occurred while retrieving availability data.",
      missingFields: "Please complete all required fields, including email, treatment type, and shift.",
      bookingSuccess: "Appointment for {{petName}} on {{date}} at {{time}} ({{room}}) has been successfully booked in the calendar. You will receive a confirmation email at {{email}}.",
      bookingError: "Error booking the appointment on Google Calendar: {{error}}",
      privacyTitle: "Privacy Policy",
      privacyLastUpdate: "Last updated: July 29, 2025",
      privacyIntro: "This policy describes how Pontelungo Veterinary Studio collects, uses, and protects personal data in compliance with the General Data Protection Regulation (GDPR).",
      privacySection1: "1. Data Controller",
      privacyController: "The data controller is Pontelungo Veterinary Studio.",
      privacyAddress: "Via Pontelungo, 123, 17031 Albenga (SV), Italy",
      privacyPhone: "Phone: +39 0182 123456",
      privacySection2: "2. Data Collected",
      privacyDataCollectedIntro: "We collect the following personal data:",
      privacyData1: "Owner's first and last name",
      privacyData2: "Email address",
      privacyData3: "Phone number",
      privacyData4: "Pet's name and type",
      privacyData5: "Information on the requested treatment",
      privacyData6: "Additional notes provided by the user",
      privacyData7: "Booking details (date, time, shift)",
      privacySection3: "3. Purpose of Processing",
      privacyPurposeIntro: "The collected data is used to:",
      privacyPurpose1: "Manage veterinary appointment bookings",
      privacyPurpose2: "Provide requested veterinary services",
      privacyPurpose3: "Send confirmation and reminder emails",
      privacyPurpose4: "Fulfill legal and administrative obligations",
      privacySection4: "4. Legal Basis",
      privacyLegalBasisIntro: "Data processing is based on:",
      privacyLegalBasis1: "User consent for managing bookings and sending communications",
      privacyLegalBasis2: "The performance of a contract or pre-contractual obligations related to veterinary services",
      privacySection5: "5. Processing Methods",
      privacyProcessing1: "Data is processed using electronic and manual tools",
      privacyProcessing2: "We adopt security measures to protect data from unauthorized access",
      privacyProcessing3: "Data is accessible only to authorized personnel",      
      privacySection6: "6. Data Retention",
      privacyRetention: "Personal data is retained for the time necessary to provide the requested services and to comply with legal obligations, unless deletion is requested.",
      privacySection7: "7. Data Sharing with Third Parties",
      privacyThirdPartyIntro: "Data may be shared with:",
      privacyThirdParty1: "Google Calendar for appointment management, in compliance with data protection regulations.",
      privacySection8: "8. Data Subject Rights",
      privacyRightsIntro: "The user has the right to:",
      privacyRight1: "Access their personal data",
      privacyRight2: "Request rectification or deletion of data",
      privacyRight3: "Restrict data processing",
      privacyRight4: "Object to data processing",
      privacyRight5: "Request data portability",
      privacyRightsContact: "To exercise these rights, contact:",
      privacySection9: "9. Complaints",
      privacyComplaints: "For any complaints, you may contact the Italian Data Protection Authority or the relevant supervisory authority.",
      privacySection10: "10. Updates",      
      cookieText: "We use cookies to manage bookings and improve your experience. Read our ",
      cookieDetails: " for more details.",
      Accetta: "Accept",
      Rifiuta: "Reject",
      bookingStatus: "Booking in progress...",
      bannerTextPrenota: "Notice to our clients: if you wish to book a specialist consultation or an appointment outside the available times shown on the website, please contact the veterinary practice by phone at the following number",
      privacyUpdates: "This policy may be updated periodically. Please review it regularly.",
      sundayNotAvailable: "Sundays are not available for booking."
    }
  },
  fr: {
    translation: {
      title: "Dr. Nicolò Pareto - Vétérinaire : Soins professionnels pour vos animaux",
      ctaTitle: "Réservez une visite dès aujourd'hui",
      allestimentoTxt: "Nous travaillons à la création de contenu fantastique. Revenez bientôt pour découvrir les nouveautés !",
      generazioniTxt: "Depuis des générations, la famille Pareto se consacre avec passion au monde animal : de l'élevage de poules à la médecine vétérinaire, toujours avec amour et compétence pour le bien-être animal.",
      ctaDescription: "Ne tardez pas ! Réservez dès maintenant un rendez-vous pour votre compagnon à quatre pattes et assurez-lui les meilleurs soins possibles.",
      btnPrenota: "Réserver maintenant",
      serviceTitle: "Nos Services",
      contactsTitle: "Contacts",
      addressLabel: "Adresse:",
      phoneLabel: "Téléphone:",
      emailLabel: "Email:",
      openingHoursTitle: "Horaires",
      weekdaysHours: "Lun-mer et ven:",
      thursdayMorningLabel: "Jeudi matin:",
      saturdayHours: "Samedi:",
      sundayLabel: "Dimanche:",
      closedLabel: "Fermé",
      services: "Nos Services",
      sectionTitle2: "Pourquoi Nous Choisir",
      featureTitle1: "Soins Bienveillants",
      featureDescr1: "Nous traitons chaque animal avec amour et respect, comme s'il était le nôtre.",
      featureTitle2: "Expertise Prouvée",
      featureDesc2: "Notre équipe de vétérinaires certifiés cumule des décennies d'expérience.",
      featureTitle3: "Horaires Flexibles",
      featureDescription3: "Rendez-vous disponibles le week-end et service de garde 24h/24 et 7j/7.",
      featureTitle4: "Espace Sûr",
      featureDescription4: "Installation ultramoderne conçue pour le confort des patients.",
      btnNav1: "Accueil",
      btnNav2: "À Propos",
      btnNav3: "Réserver une Visite",
      btnNav4: "Publications",
      infoBox1: "Vétérinaire",
      infoBox2: "Année de diplôme",
      infoBox3: "Spécialisation",
      infoBox4: "Père",
      subHeading: "L'histoire de notre famille",
      family: "Famille",
      subHeading3: "une tradition vétérinaire sur trois générations",
      nonno: "Grand-père",
      nonnotext:
        "Né en 1928, Giulio Pareto est né à Ventimiglia : fils d'un cheminot et d'une femme au foyer, sa résilience a été mise à rude épreuve pendant la Seconde Guerre mondiale. Fuyant avec sa famille sa ville natale le long des voies ferrées, il arrive à Albenga en 1944 : après la guerre, avec sa seule détermination, il ouvre une petite ferme de poules pondeuses, qui deviendra à la fin des années 80 la plus grande de Ligurie, comptant jusqu'à 15 000 animaux à son apogée. Giulio s'est éteint en 1986, laissant un vide indélébile mais un héritage qui n'a pas été abandonné. Sa vie a raconté une histoire d'amour pour les animaux, qu'il a transmise aux générations suivantes. Nous aimons nous souvenir de lui parmi ses poules bien-aimées, toujours accompagné de ses fidèles bergers belges.",
      papatext:
        "Né à Albenga en 1960, il a grandi dans la ferme avicole familiale, et sa vocation professionnelle était claire dès le départ. Diplômé en médecine vétérinaire en 1984, il s'est ensuite spécialisé en pathologie aviaire et technologie avicole en 1987 ; jusqu'en 1998, il a maintenu active la ferme historique de poules pondeuses des Pareto et a géré un second cabinet vétérinaire à Laigueglia de 1999 à 2007. En 1986, il a fondé son cabinet vétérinaire à Albenga, pierre angulaire de ce qui est devenu le Studio Vétérinaire Pontelungo. Au-delà de son engagement professionnel, Fabrizio cultive une passion pour la voile et le sport, avec un intérêt particulier pour initier les jeunes aux disciplines marines.",
      nicotext:
        "Né en 1992, Nicolò a obtenu son diplôme à la faculté de médecine vétérinaire de Pise en 2018. Il a travaillé en Irlande jusqu'en 2019 avant de retourner en Italie, où il a collaboré avec plusieurs cliniques en tant que vétérinaire généraliste et urgentiste. Depuis juillet 2019, il travaille aux côtés de son père dans l'entreprise familiale, obtenant en 2024 un certificat de praticien général (GP Cert) en endoscopie auprès de l'International School of Veterinary Postgraduate Studies (ISVPS). Nicolò collabore avec plusieurs associations pour la protection des animaux et, pendant son temps libre, cultive sa passion pour la littérature. En 2024, il a publié un roman intitulé « Saliborn, ou le Processus Créatif ».",
      teamIntro:
        "Notre équipe allie expérience, spécialisation et attention au bien-être de chaque patient. Ci-dessous, vous trouverez les professionnels qui prennent soin de vos animaux chaque jour.",
      teamSection: "Notre équipe",
      collaboratorRole: "Collaboratrice",
      birthDateLabel: "Date de naissance",
      masterLabel: "Master",
      silviaBirth: "4 décembre 2000",
      silviaSpec: "Nutrition et diététique clinique du chien et du chat",
      silviaMaster: "Master de niveau II en « Nutrition et diététique clinique du chien et du chat »",
      silviatext:
        "Silvia Scorza, née le 4 décembre 2000, a obtenu son diplôme en 2025 et s'est spécialisée en nutrition et diététique clinique du chien et du chat. Elle a également complété un Master de niveau II dans la même discipline, approfondissant l'approche nutritionnelle personnalisée pour soutenir la santé, la prévention et les parcours cliniques des animaux de compagnie. Elle apporte à l'équipe une expertise actualisée et une attention particulière au bien-être alimentaire des chiens et des chats.",
      serv1: "Consultations de médecine générale",
      serv2: "Chirurgie",
      serv3: "Diagnostic avancé",
      serv4: "Médecine préventive",
      serv5: "Gestion des urgences",
      serv6: "Nutrition et diététique clinique",
      service1Title: "Médecine Générale",
      service1Description: "Visites de routine et contrôles préventifs pour maintenir votre animal en bonne santé.",
      service1Date: "Tous les jours",
      service1Tag: "Service de Base",
      service2Title: "Chirurgie Vétérinaire",
      service2Description: "Interventions chirurgicales spécialisées réalisées par notre équipe experte dans un environnement stérile et sûr.",
      service2Date: "Sur rendez-vous",
      service2Tag: "Spécialisé",
      service3Title: "Diagnostic Avancé",
      service3Description: "Radiographies, échographies et analyses de laboratoire pour des diagnostics précis et rapides.",
      service3Date: "Sur rendez-vous",
      service3Tag: "Diagnostique",
      philosophy: "Notre Philosophie",
      philosophy1: "Soins personnalisés pour chaque animal",
      philosophy2: "Environnement à faible stress",
      philosophy3: "Implication des propriétaires",
      philosophy4: "Prévention comme priorité",
      welcome: "Bienvenue au Studio Vétérinaire Pontelungo",
      subtitle: "Depuis plus de 40 ans, nous prenons soin de vos animaux avec passion",
      logoAlt: "Studio Vétérinaire Pontelungo",
      veterinari: "Vétérinaires",
      toggleMenu: "Ouvrir/Fermer le menu",
      closeMenu: "Fermer le menu",
      backToHome: "Retour à la page d'accueil",
      slide1Title: "Studio Vétérinaire Professionnel",
      slide1Description: "Soins de qualité pour vos animaux de compagnie",
      slide1Alt: "Studio Vétérinaire",
      slide2Title: "Équipe Qualifiée",
      slide2Description: "Une équipe d'experts pour tous les besoins de votre animal",
      slide2Alt: "Équipe Qualifiée",
      slide3Title: "Équipements de Pointe",
      slide3Description: "Technologie moderne pour des diagnostics précis et rapides",
      slide3Alt: "Équipements de Pointe",
      metaDescription: "Chirurgien vétérinaire Dr. Nicolò Pareto dédié au soin et au bien-être de vos animaux de compagnie.",
      metaKeywords: "vétérinaire, studio vétérinaire, soin des animaux, animaux de compagnie, chiens, chats, visite vétérinaire",
      prevSlide: "Diapositive précédente",
      nextSlide: "Diapositive suivante",
      goToSlide: "Aller à la diapositive {{index}}",
      noImages: "Aucune image disponible",
      imageNotAvailable: "Image non disponible",
      slideAlt: "Image de diapositive",
      bookAppointmentTitle: "Réserver une visite vétérinaire",
      selectDate: "Sélectionner une date",
      cancel: "Annuler",
      confirm: "Confirmer",
      selectRoom: "Sélectionner un créneau",
      normalShift: "Salle de consultation 1",
      shift2: "Salle de consultation 2",
      availableTimesMorning: "Horaires disponibles - Matin",
      availableTimesAfternoon: "Horaires disponibles - Après-midi",
      noMorningTimes: "Aucun horaire disponible pour le matin.",
      noAfternoonTimes: "Aucun horaire disponible pour l'après-midi.",
      selectTimeSlot: "Sélectionner l'horaire {{time}} pour le Salle de consultation 1",
      selectTimeSlotShift2: "Sélectionner l'horaire {{time}} pour le Salle de consultation 2",
      googleCalendarEvents: "Événements Google Calendar pour le",
      noEvents: "Aucun événement trouvé dans Google Calendar pour cette date.",
      noTitleEvent: "Événement sans titre",
      allDayEvent: "Toute la journée",
      viewOnGoogleCalendar: "Voir sur Google Calendar",
      bookingDetails: "Détails de la réservation",
      ownerFirstName: "Prénom du propriétaire *",
      ownerLastName: "Nom du propriétaire *",
      email: "Email *",
      petName: "Nom de l'animal *",
      petType: "Type d'animal *",
      selectPetType: "Sélectionner...",
      dog: "Chien",
      cat: "Chat",
      rabbit: "Lapin",
      bird: "Oiseau",
      reptile: "Reptile",
      other: "Autre",
      treatment: "Traitement *",
      selectTreatment: "Sélectionner un traitement...",
      treatmentAnnualVaccine: "Vaccin annuel",
      treatmentCheckup: "Visite de contrôle",
      treatmentBloodTests: "Analyses de sang (préciser la raison dans les notes)",
      treatmentXRay: "Radiographie (préciser la raison dans les notes)",
      treatmentTherapy: "Administration de thérapies (préciser la raison dans les notes)",
      treatmentPreSurgery: "Visite de contrôle pré-chirurgicale",
      treatmentPostSurgery: "Visite de contrôle post-chirurgicale",
      treatmentOther: "Autre (préciser la raison dans les notes)",
      treatmentLeishmaniasis: "Vaccin contre la leishmaniose",
      treatmentFeLV: "Vaccin FeLV",
      treatmentAnnualFeLV: "Vaccin annuel + Vaccin FeLV",
      treatmentMyxoRHD: "Vaccin Myxo RHD",
      notes: "Notes",
      notesPlaceholder: "Entrez des notes ou une description du problème",
      bookingSummary: "Résumé de la réservation",
      bookingSummaryText: "Rendez-vous pour <strong>{{petName}}</strong>{{petType}} pour <strong>{{treatment}}</strong> le <strong>{{date}} à {{time}}</strong> ({{room}}). Email de confirmation à : <strong>{{email}}</strong>",
      noPetName: "(nom de l'animal)",
      noTreatment: "(aucun traitement)",
      selectTime: "Sélectionnez un horaire pour finaliser la réservation",
      bookingInProgress: "Réservation en cours...",
      confirmBooking: "Confirmer la réservation",
      calendarError: "Avertissement : Erreur lors de la récupération des événements Google Calendar. Assurez-vous que le compte de service est correctement configuré et que le calendrier est partagé.",
      criticalError: "Une erreur critique s'est produite lors de la récupération des données de disponibilité.",
      missingFields: "Veuillez remplir tous les champs obligatoires, y compris l'email, le type de traitement et le créneau.",
      bookingSuccess: "Rendez-vous pour {{petName}} le {{date}} à {{time}} ({{room}}) a été réservé avec succès dans le calendrier. Vous recevrez un email de confirmation à {{email}}.",
      bookingError: "Erreur lors de la réservation du rendez-vous sur Google Calendar : {{error}}",
      privacyTitle: "Politique de Confidentialité",
      privacyLastUpdate: "Dernière mise à jour : 29 juillet 2025",
      privacyIntro: "Cette politique décrit comment le Studio Vétérinaire Pontelungo collecte, utilise et protège les données personnelles conformément au Règlement Général sur la Protection des Données (RGPD).",
      privacySection1: "1. Responsable du traitement",
      privacyController: "Le responsable du traitement des données est le Studio Vétérinaire Pontelungo.",
      privacyAddress: "Via Pontelungo, 123, 17031 Albenga (SV), Italie",
      privacyPhone: "Téléphone : +39 0182 123456",
      privacySection2: "2. Données collectées",
      privacyDataCollectedIntro: "Nous collectons les données personnelles suivantes :",
      privacyData1: "Nom et prénom du propriétaire",
      privacyData2: "Adresse email",
      privacyData3: "Numéro de téléphone",
      privacyData4: "Nom et type de l'animal",
      privacyData5: "Informations sur le traitement requis",
      privacyData6: "Notes supplémentaires fournies par l'utilisateur",
      privacyData7: "Détails de la réservation (date, heure, créneau)",
      privacySection3: "3. Finalités du traitement",
      privacyPurposeIntro: "Les données collectées sont utilisées pour :",
      privacyPurpose1: "Gérer les réservations de visites vétérinaires",
      privacyPurpose2: "Fournir les services vétérinaires demandés",
      privacyPurpose3: "Envoyer des confirmations et rappels par email",
      privacyPurpose4: "Respecter les obligations légales et administratives",
      privacySection4: "4. Base juridique",
      privacyLegalBasisIntro: "Le traitement des données repose sur :",
      privacyLegalBasis1: "Le consentement de l'utilisateur pour la gestion des réservations et l'envoi de communications",
      privacyLegalBasis2: "L'exécution d'un contrat ou d'obligations précontractuelles liées aux services vétérinaires",
      privacySection5: "5. Méthodes de traitement",
      privacyProcessing1: "Les données sont traitées avec des outils électroniques et manuels",
      privacyProcessing2: "Nous adoptons des mesures de sécurité pour protéger les données contre les accès non autorisés",
      privacyProcessing3: "Les données ne sont accessibles qu'au personnel autorisé",
      privacySection6: "6. Conservation des Données",
      privacyRetention: "Les données personnelles sont conservées pendant le temps nécessaire pour fournir les services demandés et pour respecter les obligations légales, sauf demande de suppression.",
      privacySection7: "7. Partage des données avec des tiers",
      privacyThirdPartyIntro: "Les données peuvent être partagées avec :",
      privacyThirdParty1: "Google Calendar pour la gestion des rendez-vous, conformément aux réglementations sur la protection des données.",
      privacySection8: "8. Droits des personnes concernées",
      privacyRightsIntro: "L'utilisateur a le droit de :",
      privacyRight1: "Accéder à ses données personnelles",
      privacyRight2: "Demander la rectification ou la suppression des données",
      privacyRight3: "Restreindre le traitement des données",
      privacyRight4: "S'opposer au traitement des données",
      privacyRight5: "Demander la portabilité des données",
      privacyRightsContact: "Pour exercer ces droits, contactez :",
      privacySection9: "9. Réclamations",
      privacyComplaints: "Pour toute réclamation, vous pouvez contacter l'Autorité italienne de protection des données ou l'autorité de contrôle compétente.",
      privacySection10: "10. Mises à jour",
      cookieText: "Nous utilisons des cookies pour gérer les réservations et améliorer votre expérience. Lisez notre ",
      cookieDetails: " pour plus de détails.",
      Accetta: "Accepter",
      Rifiuta: "Refuser",
      bookingStatus: "Réservation en cours...",
      bookingSuccessModal: "Un rendez-vous vétérinaire a été réservé pour votre animal {{petName}} ({{petType}}). Un courriel de confirmation a été envoyé à l'adresse {{email}}.",
      bannerTextPrenota: "Avis à nos clients : si vous souhaitez prendre rendez-vous pour une consultation spécialisée ou en dehors des horaires disponibles sur le site, veuillez contacter le cabinet vétérinaire par téléphone au numéro suivant",
      privacyUpdates: "Cette politique peut être mise à jour périodiquement. Veuillez la consulter régulièrement.",
      sundayNotAvailable: "Les dimanches ne sont pas disponibles pour les réservations."
    }
  },
  es: {
    translation: {
      title: "Dr. Nicolò Pareto Veterinario - Cuidado profesional para tus animales",
      ctaTitle: "Reserva una Cita Hoy",
      ctaDescription: "¡No esperes! Reserva ahora una cita para tu amigo de cuatro patas y asegúrale los mejores cuidados posibles.",
      btnPrenota: "Reservar ahora",
      allestimentoTxt: "Estamos trabajando para crear contenido fantástico. ¡Vuelve pronto para descubrir las novedades!",
      generazioniTxt: "Durante generaciones, la familia Pareto se ha dedicado con pasión al mundo de los animales: desde la cría de gallinas hasta la medicina veterinaria, siempre con amor y competencia por el bienestar animal.",
      serviceTitle: "Nuestros Servicios",
      services: "Nuestros Servicios",
      contactsTitle: "Contactos",
      addressLabel: "Dirección:",
      phoneLabel: "Teléfono:",
      emailLabel: "Correo:",
      openingHoursTitle: "Horario",
      weekdaysHours: "Lun-mié y vie:",
      thursdayMorningLabel: "Jueves por la mañana:",
      saturdayHours: "Sábado:",
      sundayLabel: "Domingo:",
      closedLabel: "Cerrado",
      sectionTitle2: "Por Qué Elegirnos",
      featureTitle1: "Cuidado Compasivo",
      featureDescr1: "Tratamos a cada animal con amor y respeto, como si fuera nuestro.",
      featureTitle2: "Experiencia Comprobada",
      featureDesc2: "Nuestro equipo de veterinarios certificados cuenta con décadas de experiencia combinada.",
      featureTitle3: "Horarios Flexibles",
      featureDescription3: "Citas disponibles los fines de semana y servicio de guardia 24/7.",
      featureTitle4: "Espacio Seguro",
      featureDescription4: "Instalación de última generación diseñada para la comodidad de los pacientes.",
      btnNav1: "Inicio",
      btnNav2: "Sobre Nosotros",
      btnNav3: "Reservar una Cita",
      btnNav4: "Publicaciones",
      infoBox1: "Veterinario",
      infoBox2: "Año de graduación",
      infoBox3: "Especialización",
      infoBox4: "Padre",
      subHeading: "La historia de nuestra familia",
      family: "Familia",
      subHeading3: "una tradición veterinaria de tres generaciones",
      nonno: "Abuelo",
      nonnotext:
        "Nacido en 1928, Giulio Pareto nació en Ventimiglia: hijo de un ferroviario y una ama de casa, su resiliencia fue puesta a prueba durante la Segunda Guerra Mundial. Huyendo con su familia de su ciudad natal a lo largo de las vías del ferrocarril, llegó a Albenga en 1944: después de la guerra, con pura determinación, abrió una pequeña granja de gallinas ponedoras, que a finales de los años 80 se convirtió en la más grande de Liguria, alcanzando un máximo de 15.000 animales. Giulio falleció en 1986, dejando un vacío imborrable pero un legado que no ha sido abandonado. Su vida contó una historia de amor por los animales, que transmitió a las generaciones futuras. Lo recordamos con cariño entre sus queridas gallinas, siempre acompañado por sus fieles pastores belgas.",
      papatext:
        "Nacido en Albenga en 1960, creció en la granja avícola familiar, y su vocación profesional fue clara desde el principio. Graduado en Medicina Veterinaria en 1984, se especializó posteriormente en Patología Aviar y Tecnología Avícola en 1987; hasta 1998 mantuvo activa la histórica granja de gallinas ponedoras de los Pareto y gestionó una segunda clínica veterinaria en Laigueglia de 1999 a 2007. En 1986 fundó su clínica veterinaria en Albenga, piedra angular de lo que luego se convirtió en el Estudio Veterinario Pontelungo. Además de su compromiso profesional, Fabrizio cultiva una pasión por la vela y el deporte, con un enfoque particular en acercar a los jóvenes a las disciplinas marinas.",
      nicotext:
        "Nacido en 1992, Nicolò se graduó en la Facultad de Medicina Veterinaria de Pisa en 2018. Trabajó en Irlanda hasta 2019 antes de regresar a Italia, donde colaboró con varias clínicas como veterinario generalista y de emergencias. Desde julio de 2019, ha trabajado junto a su padre en el negocio familiar, obteniendo en 2024 el Certificado de Práctica General (GP Cert) en Endoscopia en la International School of Veterinary Postgraduate Studies (ISVPS). Nicolò colabora con varias asociaciones para la protección de animales y, en su tiempo libre, cultiva su pasión por la literatura. En 2024, publicó una novela titulada 'Saliborn, o el Proceso Creativo'.",
      teamIntro:
        "Nuestro equipo une experiencia, especialización y atención al bienestar de cada paciente. A continuación encontrarás a los profesionales que cuidan de tus animales cada día.",
      teamSection: "Nuestro equipo",
      collaboratorRole: "Colaboradora",
      birthDateLabel: "Fecha de nacimiento",
      masterLabel: "Máster",
      silviaBirth: "4 de diciembre de 2000",
      silviaSpec: "Nutrición y dietética clínica del perro y del gato",
      silviaMaster: 'Máster de II nivel en "Nutrición y dietética clínica del perro y del gato"',
      silviatext:
        "Silvia Scorza, nacida el 4 de diciembre de 2000, se graduó en 2025 y se especializó en nutrición y dietética clínica del perro y del gato. También completó un Máster de II nivel en la misma disciplina, profundizando en el enfoque nutricional personalizado para apoyar la salud, la prevención y los recorridos clínicos de los animales de compañía. Aporta al equipo competencia actualizada y una especial atención al bienestar alimentario de perros y gatos.",
      serv1: "Visitas de medicina general",
      serv2: "Cirugía",
      serv3: "Diagnóstico avanzado",
      serv4: "Medicina preventiva",
      serv5: "Gestión de emergencias",
      serv6: "Nutrición y dietética clínica",
      service1Title: "Medicina General",
      service1Description: "Visitas de rutina y chequeos preventivos para mantener a tu mascota en buena salud.",
      service1Date: "Todos los días",
      service1Tag: "Servicio Básico",
      service2Title: "Cirugía Veterinaria",
      service2Description: "Procedimientos quirúrgicos especializados realizados por nuestro equipo experto en un entorno estéril y seguro.",
      service2Date: "Con cita previa",
      service2Tag: "Especializado",
      service3Title: "Diagnóstico Avanzado",
      service3Description: "Radiografías, ecografías y análisis de laboratorio para diagnósticos precisos y oportunos.",
      service3Date: "Con cita previa",
      service3Tag: "Diagnóstico",
      philosophy: "Nuestra Filosofía",
      philosophy1: "Cuidado personalizado para cada animal",
      philosophy2: "Entorno de bajo estrés",
      philosophy3: "Involucración de los propietarios",
      philosophy4: "Prevención como prioridad",
      welcome: "Bienvenidos al Estudio Veterinario Pontelungo",
      subtitle: "Desde hace más de 40 años, cuidamos con pasión de tus animales",
      logoAlt: "Estudio Veterinario Pontelungo",
      veterinari: "Veterinarios",
      toggleMenu: "Abrir/Cerrar menú",
      closeMenu: "Cerrar menú",
      backToHome: "Volver a la página principal",
      slide1Title: "Estudio Veterinario Profesional",
      slide1Description: "Cuidado de calidad para tus mascotas",
      slide1Alt: "Estudio Veterinario",
      slide2Title: "Personal Cualificado",
      slide2Description: "Un equipo de expertos para cada necesidad de tu mascota",
      slide2Alt: "Personal Cualificado",
      slide3Title: "Equipos de Vanguardia",
      slide3Description: "Tecnología moderna para diagnósticos precisos y oportunos",
      slide3Alt: "Equipos de Vanguardia",
      metaDescription: "Cirujano veterinario Dr. Nicolò Pareto dedicado al cuidado y bienestar de tus mascotas.",
      metaKeywords: "veterinario, estudio veterinario, cuidado de animales, mascotas, perros, gatos, visita veterinaria",
      prevSlide: "Diapositiva anterior",
      nextSlide: "Diapositiva siguiente",
      goToSlide: "Ir a la diapositiva {{index}}",
      noImages: "No hay imágenes disponibles",
      imageNotAvailable: "Imagen no disponible",
      slideAlt: "Imagen de diapositiva",
      bookAppointmentTitle: "Reservar una cita veterinaria",
      selectDate: "Seleccionar una fecha",
      cancel: "Cancelar",
      confirm: "Confirmar",
      selectRoom: "Seleccionar Sala",
      normalShift: "Sala de consulta 1",
      shift2: "Sala de consulta 2",
      availableTimesMorning: "Horarios disponibles - Mañana",
      availableTimesAfternoon: "Horarios disponibles - Tarde",
      noMorningTimes: "No hay horarios disponibles para la mañana.",
      noAfternoonTimes: "No hay horarios disponibles para la tarde.",
      selectTimeSlot: "Seleccionar horario {{time}} para Sala de consulta 1",
      selectTimeSlotShift2: "Seleccionar horario {{time}} para Sala de consulta 2",
      googleCalendarEvents: "Eventos de Google Calendar para el",
      noEvents: "No se encontraron eventos en Google Calendar para esta fecha.",
      noTitleEvent: "Evento sin título",
      allDayEvent: "Todo el día",
      viewOnGoogleCalendar: "Ver en Google Calendar",
      bookingDetails: "Detalles de la reserva",
      ownerFirstName: "Nombre del propietario *",
      ownerLastName: "Apellido del propietario *",
      email: "Email *",
      petName: "Nombre de la mascota *",
      petType: "Tipo de animal *",
      selectPetType: "Seleccionar...",
      dog: "Perro",
      cat: "Gato",
      rabbit: "Conejo",
      bird: "Pájaro",
      reptile: "Reptil",
      other: "Otro",
      treatment: "Tratamiento *",
      selectTreatment: "Seleccionar un tratamiento...",
      treatmentAnnualVaccine: "Vacuna anual",
      treatmentCheckup: "Chequeo",
      treatmentBloodTests: "Análisis de sangre (especificar motivo en notas)",
      treatmentXRay: "Radiografía (especificar motivo en notas)",
      treatmentTherapy: "Administración de terapias (especificar motivo en notas)",
      treatmentPreSurgery: "Chequeo pre-quirúrgico",
      treatmentPostSurgery: "Chequeo post-quirúrgico",
      treatmentOther: "Otro (especificar motivo en notas)",
      treatmentLeishmaniasis: "Vacuna contra leishmaniosis",
      treatmentFeLV: "Vacuna FeLV",
      treatmentAnnualFeLV: "Vacuna anual + Vacuna FeLV",
      treatmentMyxoRHD: "Vacuna Myxo RHD",
      notes: "Notas",
      notesPlaceholder: "Ingresa cualquier nota o descripción del problema",
      bookingSummary: "Resumen de la reserva",
      bookingSummaryText: "Cita para <strong>{{petName}}</strong>{{petType}} para <strong>{{treatment}}</strong> el <strong>{{date}} a las {{time}}</strong> ({{room}}). Email de confirmación a: <strong>{{email}}</strong>",
      noPetName: "(nombre de la mascota)",
      noTreatment: "(ningún tratamiento)",
      selectTime: "Selecciona un horario para completar la reserva",
      bookingInProgress: "Reserva en curso...",
      confirmBooking: "Confirmar reserva",
      calendarError: "Advertencia: Error al recuperar los eventos de Google Calendar. Asegúrate de que la cuenta de servicio esté configurada correctamente y que el calendario esté compartido.",
      criticalError: "Ocurrió un error crítico al recuperar los datos de disponibilidad.",
      missingFields: "Por favor, completa todos los campos obligatorios, incluido el email, el tipo de tratamiento y el turno.",
      bookingSuccess: "Cita para {{petName}} el {{date}} a las {{time}} ({{room}}) ha sido reservada con éxito en el calendario. Recibirás un email de confirmación en {{email}}.",
      bookingError: "Error al reservar la cita en Google Calendar: {{error}}",
      privacyTitle: "Política de Privacidad",
      privacyLastUpdate: "Última actualización: 29 de julio de 2025",
      privacyIntro: "Esta política describe cómo el Estudio Veterinario Pontelungo recopila, utiliza y protege los datos personales de acuerdo con el Reglamento General de Protección de Datos (GDPR).",
      privacySection1: "1. Responsable del tratamiento",
      privacyController: "El responsable del tratamiento de datos es el Estudio Veterinario Pontelungo.",
      privacyAddress: "Via Pontelungo, 123, 17031 Albenga (SV), Italia",
      privacyPhone: "Teléfono: +39 0182 123456",
      privacySection2: "2. Datos recopilados",
      privacyDataCollectedIntro: "Recopilamos los siguientes datos personales:",
      privacyData1: "Nombre y apellido del propietario",
      privacyData2: "Dirección de correo electrónico",
      privacyData3: "Número de teléfono",
      privacyData4: "Nombre y tipo de animal",
      privacyData5: "Información sobre el tratamiento solicitado",
      privacyData6: "Notas adicionales proporcionadas por el usuario",
      privacyData7: "Detalles de la reserva (fecha, hora, turno)",
      privacySection3: "3. Finalidad del tratamiento",
      privacyPurposeIntro: "Los datos recopilados se utilizan para:",
      privacyPurpose1: "Gestionar las reservas de citas veterinarias",
      privacyPurpose2: "Proporcionar los servicios veterinarios solicitados",
      privacyPurpose3: "Enviar confirmaciones y recordatorios por correo electrónico",
      privacyPurpose4: "Cumplir con las obligaciones legales y administrativas",
      privacySection4: "4. Base jurídica",
      privacyLegalBasisIntro: "El tratamiento de datos se basa en:",
      privacyLegalBasis1: "El consentimiento del usuario para la gestión de reservas y el envío de comunicaciones",
      privacyLegalBasis2: "La ejecución de un contrato u obligaciones precontractuales relacionadas con los servicios veterinarios",
      privacySection5: "5. Métodos de tratamiento",
      privacyProcessing1: "Los datos se procesan con herramientas electrónicas y manuales",
      privacyProcessing2: "Adoptamos medidas de seguridad para proteger los datos contra accesos no autorizados",
      privacyProcessing3: "Los datos solo son accesibles para el personal autorizado",
      privacySection6: "6. Conservación de Datos",
      privacyRetention: "Los datos personales se conservan durante el tiempo necesario para proporcionar los servicios solicitados y cumplir con las obligaciones legales, salvo solicitud de eliminación.",
      privacySection7: "7. Comunicación a terceros",
      privacyThirdPartyIntro: "Los datos pueden compartirse con:",
      privacyThirdParty1: "Google Calendar para la gestión de citas, cumpliendo con las normativas de protección de datos.",
      privacySection8: "8. Derechos del interesado",
      privacyRightsIntro: "El usuario tiene derecho a:",
      privacyRight1: "Acceder a sus datos personales",
      privacyRight2: "Solicitar la rectificación o eliminación de datos",
      privacyRight3: "Restringir el tratamiento de datos",
      privacyRight4: "Oponerse al tratamiento de datos",
      privacyRight5: "Solicitar la portabilidad de datos",
      privacyRightsContact: "Para ejercer estos derechos, contacta:",
      privacySection9: "9. Reclamaciones",
      privacyComplaints: "Para cualquier reclamación, puedes contactar con la Autoridad Italiana de Protección de Datos o la autoridad de control competente.",
      privacySection10: "10. Actualizaciones",
      cookieText: "Utilizamos cookies para gestionar reservas y mejorar tu experiencia. Lee nuestra ",
      cookieDetails: " para más detalles.",
      Accetta: "Aceptar",
      Rifiuta: "Rechazar",
      bookingStatus: "Reserva en curso...",
      bookingSuccessModal: "Se ha reservado una cita veterinaria para tu mascota {{petName}} ({{petType}}). Se ha enviado un correo electrónico de confirmación a la dirección {{email}}.",
      bannerTextPrenota: "Aviso a los clientes: si desea reservar una consulta especializada o fuera de los horarios disponibles en la web, por favor contacte telefónicamente con la clínica veterinaria en el siguiente número",
      privacyUpdates: "Esta política puede actualizarse periódicamente. Por favor, consúltala regularmente.",
      sundayNotAvailable: "Los domingos no están disponibles para reservas."
    }
  },
  de: {
    translation: {
      title: "Dr. Nicolò Pareto Tierarzt - Professionelle Pflege für Ihre Tiere",
      ctaTitle: "Buchen Sie noch heute einen Termin",
      allestimentoTxt: "Wir arbeiten daran, fantastische Inhalte zu erstellen. Kommen Sie bald wieder, um zu erfahren, was es Neues gibt!",
      generazioniTxt: "Seit Generationen widmet sich die Familie Pareto mit Leidenschaft der Tierwelt: von der Hühnerzucht bis zur Tiermedizin, stets mit Liebe und Kompetenz für das Tierwohl.",
      ctaDescription: "Warten Sie nicht! Buchen Sie jetzt einen Termin für Ihren vierbeinigen Freund und sichern Sie ihm die bestmögliche Pflege.",
      btnPrenota: "Jetzt buchen",
      contactsTitle: "Kontakt",
      addressLabel: "Adresse:",
      phoneLabel: "Telefon:",
      emailLabel: "E-Mail:",
      openingHoursTitle: "Öffnungszeiten",
      weekdaysHours: "Mo-Mi & Fr:",
      thursdayMorningLabel: "Donnerstag Vormittag:",
      saturdayHours: "Samstag:",
      sundayLabel: "Sonntag:",
      closedLabel: "Geschlossen",
      serviceTitle: "Unsere Dienstleistungen",
      services: "Unsere Dienstleistungen",
      sectionTitle2: "Warum Uns Wählen",
      featureTitle1: "Mitfühlende Pflege",
      featureDescr1: "Wir behandeln jedes Tier mit Liebe und Respekt, als wäre es unser eigenes.",
      featureTitle2: "Bewährte Expertise",
      featureDesc2: "Unser Team zertifizierter Tierärzte bringt Jahrzehnte kombinierter Erfahrung mit.",
      featureTitle3: "Flexible Öffnungszeiten",
      featureDescription3: "Termine am Wochenende verfügbar und 24/7 Bereitschaftsdienst.",
      featureTitle4: "Sicherer Raum",
      featureDescription4: "Eine hochmoderne Einrichtung, die für den Komfort der Patienten entwickelt wurde.",
      btnNav1: "Startseite",
      btnNav2: "Über Uns",
      btnNav3: "Termin Buchen",
      btnNav4: "Publikationen",
      infoBox1: "Tierarzt",
      infoBox2: "Abschlussjahr",
      infoBox3: "Fachrichtung",
      infoBox4: "Vater",
      subHeading: "Unsere Familiengeschichte",
      family: "Familie",
      subHeading3: "eine tierärztliche Tradition über drei Generationen",
      nonno: "Großvater",
      nonnotext:
        "Geboren 1928, wurde Giulio Pareto in Ventimiglia geboren: Sohn eines Eisenbahners und einer Hausfrau, wurde seine Widerstandsfähigkeit während des Zweiten Weltkriegs auf die Probe gestellt. Auf der Flucht mit seiner Familie aus seiner Heimatstadt entlang der Eisenbahnschienen kam er 1944 in Albenga an: Nach dem Krieg eröffnete er mit purer Entschlossenheit eine kleine Legehennenzucht, die Ende der 1980er Jahre die größte in Ligurien wurde und in der Hochzeit bis zu 15.000 Tiere zählte. Giulio verstarb 1986 und hinterließ eine unauslöschliche Lücke, aber ein Erbe, das nicht aufgegeben wurde. Sein Leben erzählte eine Geschichte der Liebe zu Tieren, die er an zukünftige Generationen weitergab. Wir erinnern uns gerne an ihn inmitten seiner geliebten Hühner, stets begleitet von seinen treuen belgischen Schäferhunden.",
      papatext:
        "Geboren 1960 in Albenga, wuchs er in der familieneigenen Geflügelfarm auf, und seine berufliche Berufung war von Anfang an klar. Nach seinem Abschluss in Veterinärmedizin 1984 spezialisierte er sich 1987 auf Geflügelpathologie und Geflügeltechnologie; bis 1998 hielt er die historische Legehennenzucht der Paretos aktiv und leitete von 1999 bis 2007 eine zweite Tierarztpraxis in Laigueglia. 1986 gründete er seine Tierarztpraxis in Albenga, die zum Grundpfeiler des späteren Pontelungo Veterinärstudios wurde. Neben seinem beruflichen Engagement pflegt Fabrizio eine Leidenschaft für Segeln und Sport, mit einem besonderen Fokus darauf, junge Menschen an maritime Disziplinen heranzuführen.",
      nicotext:
        "Geboren 1992, absolvierte Nicolò 2018 die Fakultät für Veterinärmedizin in Pisa. Bis 2019 arbeitete er in Irland, bevor er nach Italien zurückkehrte, wo er mit verschiedenen Kliniken als allgemeiner und Notfall-Tierarzt zusammenarbeitete. Seit Juli 2019 arbeitet er zusammen mit seinem Vater in der Familienpraxis und erlangte 2024 das General Practitioner Certificate (GP Cert) in Endoskopie an der International School of Veterinary Postgraduate Studies (ISVPS). Nicolò arbeitet mit mehreren Tierschutzorganisationen zusammen und pflegt in seiner Freizeit seine Leidenschaft für Literatur. 2024 veröffentlichte er einen Roman mit dem Titel „Saliborn oder der kreative Prozess“.",
      teamIntro:
        "Unser Team verbindet Erfahrung, Spezialisierung und Aufmerksamkeit für das Wohlbefinden jedes Patienten. Hier finden Sie die Fachleute, die sich jeden Tag um Ihre Tiere kümmern.",
      teamSection: "Unser Team",
      collaboratorRole: "Mitarbeiterin",
      birthDateLabel: "Geburtsdatum",
      masterLabel: "Master",
      silviaBirth: "4. Dezember 2000",
      silviaSpec: "Klinische Ernährung und Diätetik von Hund und Katze",
      silviaMaster: "Master II. Stufe in „Klinische Ernährung und Diätetik von Hund und Katze“",
      silviatext:
        "Silvia Scorza, geboren am 4. Dezember 2000, schloss 2025 ihr Studium ab und spezialisierte sich auf klinische Ernährung und Diätetik von Hund und Katze. Sie absolvierte außerdem einen Master II. Stufe in derselben Disziplin und vertiefte den personalisierten ernährungsbezogenen Ansatz zur Unterstützung von Gesundheit, Prävention und klinischen Behandlungswegen von Haustieren. Sie bringt aktualisiertes Fachwissen und besondere Aufmerksamkeit für das Ernährungswohlbefinden von Hunden und Katzen ins Team.",
      serv1: "Allgemeinmedizinische Untersuchungen",
      serv2: "Chirurgie",
      serv3: "Erweiterte Diagnostik",
      serv4: "Präventivmedizin",
      serv5: "Notfallversorgung",
      serv6: "Klinische Ernährung und Diätetik",
      service1Title: "Allgemeine Medizin",
      service1Description: "Routinebesuche und vorbeugende Untersuchungen, um Ihr Haustier gesund zu halten.",
      service1Date: "Jeden Tag",
      service1Tag: "Grunddienst",
      service2Title: "Tierchirurgie",
      service2Description: "Spezialisierte chirurgische Eingriffe, durchgeführt von unserem erfahrenen Team in einer sterilen und sicheren Umgebung.",
      service2Date: "Nach Vereinbarung",
      service2Tag: "Spezialisiert",
      service3Title: "Erweiterte Diagnostik",
      service3Description: "Röntgenaufnahmen, Ultraschall und Labortests für präzise und zeitnahe Diagnosen.",
      service3Date: "Nach Vereinbarung",
      service3Tag: "Diagnostik",
      philosophy: "Unsere Philosophie",
      philosophy1: "Personalisierte Pflege für jedes Tier",
      philosophy2: "Stressarme Umgebung",
      philosophy3: "Einbindung der Besitzer",
      philosophy4: "Prävention als Priorität",
      welcome: "Willkommen im Pontelungo Veterinärstudio",
      subtitle: "Seit über 40 Jahren kümmern wir uns leidenschaftlich um Ihre Tiere",
      logoAlt: "Pontelungo Veterinärstudio",
      veterinari: "Tierärzte",
      toggleMenu: "Menü öffnen/schließen",
      closeMenu: "Menü schließen",
      backToHome: "Zurück zur Startseite",
      slide1Title: "Professionelles Veterinärstudio",
      slide1Description: "Qualitativ hochwertige Pflege für Ihre Haustiere",
      slide1Alt: "Veterinärstudio",
      slide2Title: "Qualifiziertes Personal",
      slide2Description: "Ein Team von Experten für alle Bedürfnisse Ihres Haustiers",
      slide2Alt: "Qualifiziertes Personal",
      slide3Title: "Modernste Ausrüstung",
      slide3Description: "Moderne Technologie für präzise und zeitnahe Diagnosen",
      slide3Alt: "Modernste Ausrüstung",
      metaDescription: "Tierchirurg Dr. Nicolò Pareto widmet sich der Pflege und dem Wohlbefinden Ihrer Haustiere.",
      metaKeywords: "Tierarzt, Veterinärstudio, Tierpflege, Haustiere, Hunde, Katzen, Tierarztbesuch",
      prevSlide: "Vorherige Folie",
      nextSlide: "Nächste Folie",
      goToSlide: "Gehe zu Folie {{index}}",
      noImages: "Keine Bilder verfügbar",
      imageNotAvailable: "Bild nicht verfügbar",
      slideAlt: "Folie Bild",
      bookAppointmentTitle: "Tierarzttermin buchen",
      selectDate: "Datum auswählen",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      selectRoom: "Schicht auswählen",
      normalShift: "Untersuchungsraum 1",
      shift2: "Untersuchungsraum 2",
      availableTimesMorning: "Verfügbare Zeiten - Vormittag",
      availableTimesAfternoon: "Verfügbare Zeiten - Nachmittag",
      noMorningTimes: "Keine Zeiten am Vormittag verfügbar.",
      noAfternoonTimes: "Keine Zeiten am Nachmittag verfügbar.",
      selectTimeSlot: "Wählen Sie Uhrzeit {{time}} für Behandlungsraum 1",
      selectTimeSlotShift2: "Wählen Sie Uhrzeit {{time}} für Behandlungsraum 2",
      googleCalendarEvents: "Google Kalender Ereignisse für",
      noEvents: "Keine Ereignisse im Google Kalender für dieses Datum gefunden.",
      noTitleEvent: "Ereignis ohne Titel",
      allDayEvent: "Ganztägig",
      viewOnGoogleCalendar: "In Google Kalender ansehen",
      bookingDetails: "Buchungsdetails",
      ownerFirstName: "Vorname des Besitzers *",
      ownerLastName: "Nachname des Besitzers *",
      email: "Email *",
      petName: "Name des Haustiers *",
      petType: "Tierart *",
      selectPetType: "Auswählen...",
      dog: "Hund",
      cat: "Katze",
      rabbit: "Kaninchen",
      bird: "Vogel",
      reptile: "Reptil",
      other: "Andere",
      treatment: "Behandlung *",
      selectTreatment: "Eine Behandlung auswählen...",
      treatmentAnnualVaccine: "Jährliche Impfung",
      treatmentCheckup: "Untersuchung",
      treatmentBloodTests: "Bluttests (Grund in Notizen angeben)",
      treatmentXRay: "Röntgenaufnahme (Grund in Notizen angeben)",
      treatmentTherapy: "Verabreichung von Therapien (Grund in Notizen angeben)",
      treatmentPreSurgery: "Voruntersuchung vor Operation",
      treatmentPostSurgery: "Nachuntersuchung nach Operation",
      treatmentOther: "Andere (Grund in Notizen angeben)",
      treatmentLeishmaniasis: "Impfung gegen Leishmaniose",
      treatmentFeLV: "FeLV-Impfung",
      treatmentAnnualFeLV: "Jährliche Impfung + FeLV-Impfung",
      treatmentMyxoRHD: "Myxo RHD-Impfung",
      notes: "Notizen",
      notesPlaceholder: "Geben Sie Notizen oder eine Beschreibung des Problems ein",
      bookingSummary: "Buchungszusammenfassung",
      bookingSummaryText: "Termin für <strong>{{petName}}</strong>{{petType}} für <strong>{{treatment}}</strong> am <strong>{{date}} um {{time}}</strong> ({{room}}). Bestätigungsemail an: <strong>{{email}}</strong>",
      noPetName: "(Name des Haustiers)",
      noTreatment: "(keine Behandlung)",
      selectTime: "Wählen Sie eine Zeit aus, um die Buchung abzuschließen",
      bookingInProgress: "Buchung läuft...",
      confirmBooking: "Buchung bestätigen",
      calendarError: "Warnung: Fehler beim Abrufen der Google Kalender-Ereignisse. Stellen Sie sicher, dass das Dienstkonto korrekt konfiguriert ist und der Kalender freigegeben ist.",
      criticalError: "Ein kritischer Fehler ist beim Abrufen der Verfügbarkeitsdaten aufgetreten.",
      missingFields: "Bitte füllen Sie alle erforderlichen Felder aus, einschließlich Email, Behandlungsart und Schicht.",
      bookingSuccess: "Termin für {{petName}} am {{date}} um {{time}} ({{room}}) wurde erfolgreich im Kalender gebucht. Sie erhalten eine Bestätigungsemail an {{email}}.",
      bookingError: "Fehler beim Buchen des Termins im Google Kalender: {{error}}",
      privacyTitle: "Datenschutzrichtlinie",
      privacyLastUpdate: "Zuletzt aktualisiert: 29. Juli 2025",
      privacyIntro: "Diese Richtlinie beschreibt, wie das Pontelungo Veterinärstudio personenbezogene Daten gemäß der Datenschutz-Grundverordnung (DSGVO) erhebt, verwendet und schützt.",
      privacySection1: "1. Verantwortlicher für die Datenverarbeitung",
      privacyController: "Der Verantwortliche für die Datenverarbeitung ist das Pontelungo Veterinärstudio.",
      privacyAddress: "Via Pontelungo, 123, 17031 Albenga (SV), Italien",
      privacyPhone: "Telefon: +39 0182 123456",
      privacySection2: "2. Erhobene Daten",
      privacyDataCollectedIntro: "Wir erheben die folgenden personenbezogenen Daten:",
      privacyData1: "Vor- und Nachname des Besitzers",
      privacyData2: "E-Mail-Adresse",
      privacyData3: "Telefonnummer",
      privacyData4: "Name und Art des Tieres",
      privacyData5: "Informationen über die angeforderte Behandlung",
      privacyData6: "Zusätzliche Notizen des Nutzers",
      privacyData7: "Buchungsdetails (Datum, Uhrzeit, Schicht)",
      privacySection3: "3. Zweck der Verarbeitung",
      privacyPurposeIntro: "Die erhobenen Daten werden verwendet, um:",
      privacyPurpose1: "Tierarzttermine zu verwalten",
      privacyPurpose2: "Angeforderte tierärztliche Dienstleistungen bereitzustellen",
      privacyPurpose3: "Bestätigungs- und Erinnerungsemails zu senden",
      privacyPurpose4: "Gesetzliche und administrative Verpflichtungen zu erfüllen",
      privacySection4: "4. Rechtsgrundlage",
      privacyLegalBasisIntro: "Die Datenverarbeitung basiert auf:",
      privacyLegalBasis1: "Der Einwilligung des Nutzers zur Verwaltung von Buchungen und zum Versand von Mitteilungen",
      privacyLegalBasis2: "Der Erfüllung eines Vertrags oder vorvertraglicher Verpflichtungen im Zusammenhang mit tierärztlichen Dienstleistungen",
      privacySection5: "5. Verarbeitungsmethoden",
      privacyProcessing1: "Die Daten werden mit elektronischen und manuellen Werkzeugen verarbeitet",
      privacyProcessing2: "Wir treffen Sicherheitsmaßnahmen, um die Daten vor unbefugtem Zugriff zu schützen",
      privacyProcessing3: "Die Daten sind nur für autorisiertes Personal zugänglich",
      privacyRetention: "Personenbezogene Daten werden so lange aufbewahrt, wie es zur Bereitstellung der angeforderten Dienstleistungen und zur Erfüllung gesetzlicher Verpflichtungen erforderlich ist, sofern keine Löschung beantragt wird.",
      privacySection7: "7. Weitergabe von Daten an Dritte",
      privacySection6: "6. Datenspeicherung",
      privacyThirdPartyIntro: "Die Daten können weitergegeben werden an:",
      privacyThirdParty1: "Google Calendar zur Terminverwaltung, in Übereinstimmung mit den Datenschutzbestimmungen.",
      privacySection8: "8. Rechte der betroffenen Person",
      privacyRightsIntro: "Der Nutzer hat das Recht:",
      privacyRight1: "Auf seine personenbezogenen Daten zuzugreifen",
      privacyRight2: "Die Berichtigung oder Löschung der Daten zu verlangen",
      privacyRight3: "Die Einschränkung der Datenverarbeitung zu verlangen",
      privacyRight4: "Der Datenverarbeitung zu widersprechen",
      privacyRight5: "Die Datenübertragbarkeit zu verlangen",
      privacyRightsContact: "Um diese Rechte auszuüben, kontaktieren Sie:",
      privacySection9: "9. Beschwerden",
      privacyComplaints: "Für Beschwerden können Sie die italienische Datenschutzbehörde oder die zuständige Aufsichtsbehörde kontaktieren.",
      privacySection10: "10. Aktualisierungen",
      cookieText: "Wir verwenden Cookies, um Buchungen zu verwalten und Ihre Erfahrung zu verbessern. Lesen Sie unsere ",
      cookieDetails: " für weitere Details.",
      Accetta: "Akzeptieren",
      Rifiuta: "Ablehnen",
      bookingStatus: "Buchung läuft...",
      bookingSuccessModal: "Ein Tierarzttermin wurde für Ihr Haustier {{petName}} ({{petType}}) gebucht. Eine Bestätigungs-E-Mail wurde an die Adresse {{email}} gesendet.",
      bannerTextPrenota: "Hinweis für unsere Kunden: Wenn Sie einen Spezialtermin oder einen Termin außerhalb der auf der Website verfügbaren Zeiten buchen möchten, kontaktieren Sie bitte die Tierarztpraxis telefonisch unter der folgenden Nummer",
      privacyUpdates: "Diese Richtlinie kann regelmäßig aktualisiert werden. Bitte überprüfen Sie sie regelmäßig.",
      sundayNotAvailable: "Sonntage sind für Buchungen nicht verfügbar."
    }
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  })

export default i18n